import React from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { LOGO_URL } from "@/i18n/translations";
import { Button } from "@/components/ui/button";

export const LandingHeader = ({ backLabel }) => {
  const { lang, changeLang } = useLang();

  return (
    <header className="fixed top-0 inset-x-0 z-50 glass border-b border-brand/10">
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <Link to="/" className="flex items-center no-a11y-underline group" aria-label="Care For Me">
          <img src={LOGO_URL} alt="Care For Me" className="h-9 sm:h-11 w-auto transition-transform duration-300 group-hover:scale-105" />
        </Link>

        <div className="flex items-center gap-2 sm:gap-3">
          <div className="flex items-center rounded-full border border-brand/20 p-0.5 bg-white/60" role="group" aria-label="Language switcher">
            {["el", "en"].map((l) => (
              <button
                key={l}
                data-testid={`lang-switch-${l}`}
                onClick={() => changeLang(l)}
                className={`px-2.5 py-1 rounded-full text-xs font-bold uppercase transition-colors duration-200 no-a11y-underline ${
                  lang === l ? "bg-brand text-brand-cream" : "text-brand-ink/60 hover:text-brand"
                }`}
                aria-pressed={lang === l}
              >
                {l}
              </button>
            ))}
          </div>
          <Link to="/" data-testid="landing-back-home">
            <Button variant="outline" className="rounded-full border-brand/30 text-brand hover:bg-brand-soft/40 font-bold no-a11y-underline">
              <Home className="h-4 w-4 sm:mr-2" /> <span className="hidden sm:inline">{backLabel}</span>
            </Button>
          </Link>
        </div>
      </nav>
    </header>
  );
};
